import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  Paper,
  TableRow,
  IconButton,
  TextField,
  Autocomplete,
  Box,
  Chip,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

import { companyWiseEmp } from "../../actions/Companywiseclient";

const OrderManagementHeaderConfiguration = ({ companyId }) => {
  const [selectedPage, setSelectedPage] = React.useState(null);
  const [orderMgmtPageList, setOrderMgmtPageList] = React.useState([]);
  const [headerList, setHeaderList] = React.useState([]);
  const [editIndex, setEditIndex] = React.useState(null);
  const getSetHeaderList = async () => {
    debugger;
    const response = await companyWiseEmp.getAllOrderManagementHeader(
      companyId,
      selectedPage.id
    );
    if (response !== null && response.responseCode === 200) {
      setHeaderList(
        response.data.map((header) => ({ ...header, uid: crypto.randomUUID() }))
      );
      // setHeaderList(
      //   response.data.map((item) => ({
      //     ...item,
      //     inputVal: item.updatedHeaderName,
      //   }))
      // );
    }
  };

  const handleChange = (e, actualHeaderName) => {
    setHeaderList(
      headerList.map((header) => {
        if (header.actualHeaderName === actualHeaderName) {
          // return { ...header, inputVal: e.target.value };
          return { ...header, updatedHeaderName: e.target.value };
        }
        return header;
      })
    );
  };

  const handleUpdateHeaderName = async () => {
    const response = await companyWiseEmp.saveOrderDynamicHeader({
      hrmsCompanyId: companyId,
      dynamicHeaderDetails: headerList,
      pageId: selectedPage.id,
    });
    if (response !== null) {
      setEditIndex(null);
      return alert(response.responseDescription);
    }
  };

  const getSetOrderMgmtPageList = async () => {
    const response = await companyWiseEmp.getAllOrderManagementPage();
    if (response !== null && response.responseCode === 200) {
      setOrderMgmtPageList(response.data);
    } else {
      setOrderMgmtPageList([]);
    }
  };

  React.useEffect(() => {
    getSetOrderMgmtPageList();
  }, []);

  React.useEffect(() => {
    if (selectedPage) {
      setEditIndex(null);
      getSetHeaderList();
    } else {
      setHeaderList([]);
      setEditIndex(null);
    }
  }, [companyId, selectedPage]);

  return (
    <Accordion className="main_accoardian" defaultExpanded={true}>
      <AccordionSummary
        className="accordianHeader"
        expandIcon={
          <AddCircleIcon fontSize="large" style={{ color: "white" }} />
        }
        aria-controls="panel1a-content"
        style={{
          background: "rgb(10 166 141)",
          borderRadius: "10px 10px 0px 0px",
          overflow: "hidden",
        }}
      >
        <Grid>
          <h3
            style={{
              color: "#fff",
              marginLeft: "10px",
              padding: "10px 2px",
            }}
          >
            Order Management Header Configuration:-
          </h3>
        </Grid>
      </AccordionSummary>

      <AccordionDetails className="accoardian_body">
        <Box sx={{ my: 1, mx: 1 }}>
          <div className="field_box">
            <Autocomplete
              size="small"
              className="select_box_forCompanyWise"
              limitTags={1}
              id="multiple-limit-tags"
              options={orderMgmtPageList}
              getOptionLabel={(option) => option.name}
              disablePortal={true}
              fullWidth
              onChange={(event, newValue) => {
                setSelectedPage(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  margin="dense"
                  placeholder="Select Page"
                />
              )}
            />
          </div>
        </Box>
        <Grid sx={{ paddingTop: "10px" }} className="CompanyMainBox">
          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead style={{ color: "#fff", backgroundColor: "#32577e" }}>
                <TableCell className="tabalecellStyle">S.no</TableCell>
                <TableCell className="tabalecellStyle"></TableCell>
                <TableCell className="tabalecellStyle">
                  Actual Title Name
                </TableCell>
                <TableCell className="tabalecellStyle">
                  Current Title Name
                </TableCell>
                <TableCell className="tabalecellStyle">Action</TableCell>
              </TableHead>
              <TableBody>
                {Boolean(selectedPage) &&
                  headerList.map((header, index) => {
                    return (
                      <TableRow key={header.uid}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell width="110px">
                          {header?.hasOwnProperty("isForWeb") && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {Boolean(header?.isForWeb) ? (
                                <Chip label="Web" color="primary" />
                              ) : (
                                <Chip label="Mobile" color="success" />
                              )}
                            </Box>
                          )}
                        </TableCell>
                        <TableCell>{header.actualHeaderName}</TableCell>
                        <TableCell>
                          {editIndex === index ? (
                            <TextField
                              id="outlined-required"
                              label={`Edit ${header.actualHeaderName}`}
                              variant="standard"
                              name={header.actualHeaderName}
                              value={header.updatedHeaderName}
                              onChange={(e) =>
                                handleChange(e, header.actualHeaderName)
                              }
                            />
                          ) : (
                            header.updatedHeaderName
                          )}
                        </TableCell>
                        <TableCell>
                          {editIndex === index ? (
                            <IconButton onClick={() => setEditIndex(null)}>
                              <CloseIcon color="error" />
                            </IconButton>
                          ) : (
                            <IconButton onClick={() => setEditIndex(index)}>
                              <EditIcon color="success" />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid
            style={{
              placeItems: "center",
              display: "flex",
              justifyContent: "flex-end",
              paddingTop: "10px",
            }}
          >
            {Boolean(companyId) && Boolean(selectedPage) && (
              <div className="field_box">
                <div
                  className="field_box_btn1"
                  onClick={handleUpdateHeaderName}
                  style={{
                    cursor: "pointer",
                    width: "60px",
                  }}
                >
                  Save
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default OrderManagementHeaderConfiguration;
